// extracted by mini-css-extract-plugin
export var project_header = "ProjectName-module--project_header--+R7VY";
export var project_name = "ProjectName-module--project_name--KJlJd";